import "../styles/about.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import PageMeta from "./PageMeta";
import StoreCta from "./StoreCta";
import { FadeInUp, StaggerChildren, StaggerItem } from "./motion";
import HeroImage from "../images/Dog wash.jpg";
import { aboutHero, aboutSections, aboutMeta } from "../content/about";
import {
  organizationSchema,
  buildBreadcrumbSchema,
  innerPageBreadcrumbs,
} from "../content/seo";

const About = () => {
  const breadcrumbSchema = buildBreadcrumbSchema(innerPageBreadcrumbs.about);

  return (
    <main className="about">
      <PageMeta
        meta={aboutMeta}
        jsonLd={[organizationSchema, breadcrumbSchema]}
      />
      <Nav page="" />
      <FadeInUp as="header" className="page-hero">
        <h1>{aboutHero.title}</h1>
        <p>{aboutHero.subtitle}</p>
      </FadeInUp>
      <section className="content-section">
        <FadeInUp>
          <img
            src={HeroImage}
            alt="Dog being washed at a Pawwash station"
            className="about-image"
          />
        </FadeInUp>
        <StaggerChildren>
          {aboutSections.map((section) => (
            <StaggerItem key={section.title} className="info-card">
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </StaggerItem>
          ))}
        </StaggerChildren>
        <FadeInUp>
          <StoreCta className="content-cta" />
        </FadeInUp>
      </section>
      <Footer />
    </main>
  );
};

export default About;
